<template>
  <div>
    <v-card>
      <v-card-text>
        <div class="row border-bottom">
          <div class="col-xl-12 pb-3">
            <div class="font-weight-bolder font-size-lg">{{$t('CRAFTVALUE.Personal_information')}}</div>
            <div class="text-muted" v-if="user && user.recordId">
              {{$t('CRAFTVALUE.You_have_registered_successfully_account')}} : {{user.phone}}，
              <!--{{$t('CRAFTVALUE.Password')}} : 123456，-->
              {{$t('CRAFTVALUE.You_can_go_to_the_top_left_page_to_specify_an_order')}}
            </div>
          </div>
        </div>
        <div class="row border-bottom align-items-center">
          <div class="col-xl-3 pt-1 pb-1" v-show="false">
            <span class="text-muted">code</span>
            <input class="form-control form-control-sm" v-model="userInfo.code" disabled>
          </div>
          <div class="col-xl-2 pt-1 pb-1">
            <span class="text-muted">{{$t('CRAFTVALUE.NickName')}}</span>
            <input class="form-control form-control-sm" v-model="userInfo.userName" v-on:blur="saveInfo">
          </div>
          <div class="col-xl-2 pt-1 pb-1">
            <span class="text-muted">{{$t('CRAFTVALUE.ContactEmail')}}</span>
            <input class="form-control form-control-sm" v-model="userInfo.email" :disabled="userInfo && userInfo.recordId">
          </div>
          <div class="col-xl-2 pt-1 pb-1">
            <span class="text-muted">{{$t('CRAFTVALUE.MobilePhone')}}</span>
            <input class="form-control form-control-sm" v-model="userInfo.phone" :disabled="userInfo && userInfo.recordId">
          </div>
          <div class="col-xl-2 pt-1 pb-1">
            <span class="text-muted">{{$t('CRAFTVALUE.Annual_demand')}}</span>
            <div class="input-group">
              <input class="form-control form-control-sm" v-model="userInfo.annualDemand" v-on:blur="saveInfo">
              <div class="input-group-append">
                <select class="form-control form-control-sm" v-model="userInfo.unit" v-on:blur="saveInfo">
                  <option value="1">￥</option>
                  <option value="2">$</option>
                  <option value="3">㎡</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-xl-3 pt-1 pb-1">
            <span class="text-muted">{{$t('CRAFTVALUE.COUNTRY')}}</span>
            <select class="form-control form-control-sm" v-model="userInfo.country" v-on:change="saveInfo">
              <option v-for="item in countryList" :key="item.recordId" :value="item.recordId">
                {{item.countryName}}
              </option>
            </select>
            <!--            <select v-model="userInfo.country" class="form-control selectpicker" data-none-selected-text="请选择"-->
            <!--                    data-max-options="1" data-live-search="true" id="countryT" ></select>-->
          </div>
        </div>
        <div class="row border-bottom align-items-center">
          <div class="col-xl-12 pt-1 pb-1">
            <span class="text-muted">{{$t('CRAFTVALUE.Profession')}}</span>
            <template v-for="item in productTypeList">
              <label class="checkbox p-1" :key="item.recordId">
                <input type="checkbox" class="form-control" id="position" :value="item.checked" v-model="item.checked" v-on:change="checkboxChange(item,productTypeList)"/>
                <span></span>
                <label class="pl-3">{{item.value}}</label>
              </label>
            </template>
          </div>
        </div>
        <div class="row border-bottom pb-3 align-items-center" v-if="!(user && user.recordId)">
          <div class="col-xl-12 text-right pt-1 pb-1">
            <div class="pt-5">
              <button class="btn btn-sm btn-primary" v-on:click="emailRegister()">{{$t('CRAFTVALUE.Quote_immediately')}}</button>
            </div>
          </div>
        </div>
        <div class="row" v-if="user && user.recordId">
          <div class="col-xl-12">
            <div class="row border-bottom">
              <div class="col-xl-12">
                <div class="row align-items-center">
                  <div class="col-6">
                    <span class="font-weight-bolder font-size-lg">{{$t('CRAFTVALUE.Add_quoted_items_by_material_process')}}</span>
                  </div>
                  <div class="col-6 text-right">
                    <button class="btn btn-sm btn-primary" v-on:click="addCraft()">+{{$t('CRAFTVALUE.Augment')}}</button>
                  </div>
                </div>
                <div class="row" v-if="craftMaterialValue">
                  <div class="col-xl-12">
                    <span class="text-muted">{{craftMaterialValue}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12">
                <div class="row border-bottom align-items-center">
                  <div class="col-6">
                    <span class="font-weight-bolder font-size-lg">{{$t('CRAFTVALUE.Quotation_list')}}</span>
                  </div>
                  <div class="col-6 text-right">
                    <button class="btn btn-sm btn-primary" v-on:click="downloadPrint">{{$t('CRAFTVALUE.Download')}}</button>
                  </div>
                </div>
                <template v-for="(item, index) in quotationDetailList">
                  <div class="row border-bottom" :key="item.recordId">
                    <div class="col-xl-12">
                      <div class="row font-weight-bolder align-items-center">
                        <div class="col-12 pt-1 pb-1">
                          {{item.concatValue}}
                        </div>
                        <div class="col-12 text-right pt-1 pb-1" v-if="!item.fixedOffer">
                          <button class="btn btn-sm btn-danger px-1 py-1" v-on:click="delQuotationDetail(index)">{{$t('CRAFTVALUE.Delete')}}</button>
                        </div>
                      </div>
                      <div class="row align-items-center" v-if="item.fixedOffer">
                        <div class="col-8 pt-1 pb-1" >
                          {{$t('CRAFTVALUE.Unit_price_per_square_meter')}}:&nbsp;{{ activeLanguage == 'en'? "$":"￥"}} {{activeLanguage == 'en'? ((item.profitPrice ? item.profitPrice : item.fixedOffer)/(exchangeRate ? exchangeRate:7.1364).toFixed(2))
                          .toFixed(2): (item.profitPrice ? item.profitPrice : item.fixedOffer)}}/㎡
                        </div>
                        <div class="col-4 pt-1 pb-1 text-right">
                          <button class="btn btn-sm btn-danger px-1 py-1" v-on:click="delQuotationDetail(index)">{{$t('CRAFTVALUE.Delete')}}</button>
                        </div>
                      </div>
                      <div class="row" v-else>
                        <template v-for="(row, recordId) in item.areaPriceList">
                          <div class="col-xl-2 pt-1 pb-1" :key="recordId" v-if="row.areaPrice">
                            <span>{{row.areaSection}}:{{activeLanguage == 'en'? "$"+(row.areaPrice/(exchangeRate ? exchangeRate:7.1364)).toFixed(2) :"￥"+row.areaPrice}}/㎡</span>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
    <b-modal ref="addCraft" hide-footer size="xl">
      <template v-slot:modal-header="{ close }">
        <h5>{{$t('CRAFTVALUE.Quoted_item')}}</h5>
        <v-row>
          <v-col lg="12" class="text-right">
            <b-button size="sm" variant="outline-danger" @click="close()">
              {{$t('CRAFTVALUE.Close')}}
            </b-button>&nbsp;
            <b-button size="sm" variant="outline-primary" @click="confirmSelection">
              {{$t('CRAFTVALUE.Verify')}}
            </b-button>
          </v-col>
        </v-row>
      </template>
      <div class="row pb-3" v-if="craftValue">
        <div class="col-xl-12 pt-1">
          {{craftValue}}
        </div>
      </div>
      <div class="row border-top border-left">
        <div class="col-4 border-right">
          <div class="row border-bottom" :style="auditFlag === 10 ? 'background-color: #b3d4f6;' : ''" v-if="exposurePrintingList && exposurePrintingList.length > 0">
            <div class="col-xl-12 pt-2 pb-2" v-on:click="selectCraftType(10)">{{$t('PRICE.Exposure_screen_printing')}}</div>
          </div>
          <div class="row border-bottom" :style="auditFlag === 1 ? 'background-color: #b3d4f6;' : ''" v-if="boardLevelList && boardLevelList.length > 0">
            <div class="col-xl-12 pt-2 pb-2" v-on:click="selectCraftType(1)">{{$t('CRAFTVALUE.PCB_type')}}</div>
          </div>
          <div class="row border-bottom" :style="auditFlag === 2 ? 'background-color: #b3d4f6;' : ''" v-if="materialTypeList && materialTypeList.length > 0">
            <div class="col-xl-12 pt-2 pb-2" v-on:click="selectCraftType(2)">{{$t('CRAFTVALUE.Copper_clad_sheet')}}</div>
          </div>
          <div class="row border-bottom" :style="auditFlag === 3 ? 'background-color: #b3d4f6;' : ''" v-if="boardThicknessList && boardThicknessList.length > 0">
            <div class="col-xl-12 pt-2 pb-2" v-on:click="selectCraftType(3)">{{$t('CRAFTVALUE.Sheet_thickness')}}</div>
          </div>
          <div class="row border-bottom" :style="auditFlag === 4 ? 'background-color: #b3d4f6;' : ''" v-if="copperCladThicknessList && copperCladThicknessList.length > 0">
            <div class="col-xl-12 pt-2 pb-2" v-on:click="selectCraftType(4)">{{$t('CRAFTVALUE.Copper_coating_requirement')}}</div>
          </div>
          <div class="row border-bottom" :style="auditFlag === 5 ? 'background-color: #b3d4f6;' : ''" v-if="surfaceProcessList && surfaceProcessList.length > 0">
            <div class="col-xl-12 pt-2 pb-2" v-on:click="selectCraftType(5)">{{$t('CRAFTVALUE.Coating_treatment')}}</div>
          </div>
          <div class="row border-bottom" :style="auditFlag === 6 ? 'background-color: #b3d4f6;' : ''" v-if="solderMaskTypeList && solderMaskTypeList.length > 0">
            <div class="col-xl-12 pt-2 pb-2" v-on:click="selectCraftType(6)">{{$t('CRAFTVALUE.Solder_resistance_type')}}</div>
          </div>
          <div class="row border-bottom" :style="auditFlag === 7 ? 'background-color: #b3d4f6;' : ''" v-if="characterTypeList && characterTypeList.length > 0">
            <div class="col-xl-12 pt-2 pb-2" v-on:click="selectCraftType(7)">{{$t('CRAFTVALUE.Panel_character')}}</div>
          </div>
          <div class="row border-bottom" :style="auditFlag === 8 ? 'background-color: #b3d4f6;' : ''" v-if="shapingWayList && shapingWayList.length > 0">
            <div class="col-xl-12 pt-2 pb-2" v-on:click="selectCraftType(8)">{{$t('CRAFTVALUE.Forming_method')}}</div>
          </div>
          <div class="row border-bottom" :style="auditFlag === 9 ? 'background-color: #b3d4f6;' : ''" v-if="testMethodList && testMethodList.length > 0">
            <div class="col-xl-12 pt-2 pb-2" v-on:click="selectCraftType(9)">{{$t('CRAFTVALUE.Test_requirement')}}</div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <div class="col-xl-12" v-if="auditFlag === 10">
              <div class="checkbox-inline">
                <template v-for="item in exposurePrintingList">
                  <label class="checkbox p-3" :key="item.recordId">
                    <input type="checkbox" class="form-control" id="position" :value="item.checked" v-model="item.checked" v-on:change="handleCheckboxChange(item,exposurePrintingList)"/>
                    <span></span>
                    {{item.value}}
                  </label>
                </template>
              </div>
            </div>
            <div class="col-xl-12" v-if="auditFlag === 1">
              <div class="checkbox-inline">
                <template v-for="item in boardLevelList">
                  <label class="checkbox pb-1" :key="item.recordId" style="min-width: 7rem;">
                    <input type="checkbox" id="position" :value="item.checked" v-model="item.checked" v-on:change="handleCheckboxChange(item,boardLevelList)"/>
                    <span></span>
                    {{item.value}}
                  </label>
                </template>
              </div>
            </div>
            <div class="col-xl-12" v-if="auditFlag === 2">
              <div class="checkbox-inline">
                <template v-for="item in materialTypeList">
                  <label class="checkbox pb-1" :key="item.recordId" style="min-width: 7rem;">
                    <input type="checkbox" id="position" :value="item.checked" v-model="item.checked" v-on:change="handleCheckboxChange(item,materialTypeList)"/>
                    <span></span>
                    {{item.value}}
                  </label>
                </template>
              </div>
            </div>
            <div class="col-xl-12" v-if="auditFlag === 3">
              <div class="checkbox-inline">
                <template v-for="item in boardThicknessList">
                  <label class="checkbox pb-1" :key="item.recordId" style="min-width: 7rem;">
                    <input type="checkbox" class="form-control" id="position" :value="item.checked" v-model="item.checked" v-on:change="handleCheckboxChange(item,boardThicknessList)"/>
                    <span></span>
                    {{item.value}}
                  </label>
                </template>
              </div>
            </div>
            <div class="col-xl-12" v-if="auditFlag === 4">
              <div class="checkbox-inline">
                <template v-for="item in copperCladThicknessList">
                  <label class="checkbox pb-1" :key="item.recordId" style="min-width: 7rem;">
                    <input type="checkbox" class="form-control" id="position" :value="item.checked" v-model="item.checked" v-on:change="handleCheckboxChange(item,copperCladThicknessList)"/>
                    <span></span>
                    {{item.value}}
                  </label>
                </template>
              </div>
            </div>
            <div class="col-xl-12" v-if="auditFlag === 5">
              <div class="checkbox-inline">
                <template v-for="item in surfaceProcessList">
                  <label class="checkbox pb-1" :key="item.recordId" style="min-width: 7rem;">
                    <input type="checkbox" class="form-control" id="position" :value="item.checked" v-model="item.checked" v-on:change="handleCheckboxChange(item,surfaceProcessList)"/>
                    <span></span>
                    {{item.value}}
                  </label>
                </template>
              </div>
            </div>
            <div class="col-xl-12" v-if="auditFlag === 6">
              <div class="checkbox-inline">
                <template v-for="item in solderMaskTypeList">
                  <label class="checkbox pb-1" :key="item.recordId" style="min-width: 7rem;">
                    <input type="checkbox" class="form-control" id="position" :value="item.checked" v-model="item.checked" v-on:change="handleCheckboxChange(item,solderMaskTypeList)"/>
                    <span></span>
                    {{item.value}}
                  </label>
                </template>
              </div>
            </div>
            <div class="col-xl-12" v-if="auditFlag === 7">
              <div class="checkbox-inline">
                <template v-for="item in characterTypeList">
                  <label class="checkbox pb-1" :key="item.recordId" style="min-width: 7rem;">
                    <input type="checkbox" class="form-control" id="position" :value="item.checked" v-model="item.checked" v-on:change="handleCheckboxChange(item,characterTypeList)"/>
                    <span></span>
                    {{item.value}}
                  </label>
                </template>
              </div>
            </div>
            <div class="col-xl-12" v-if="auditFlag === 8">
              <div class="checkbox-inline">
                <template v-for="item in shapingWayList">
                  <label class="checkbox pb-1" :key="item.recordId" style="min-width: 7rem;">
                    <input type="checkbox" class="form-control" id="position" :value="item.checked" v-model="item.checked" v-on:change="handleCheckboxChange(item,shapingWayList)"/>
                    <span></span>
                    {{item.value}}
                  </label>
                </template>
              </div>
            </div>
            <div class="col-xl-12" v-if="auditFlag === 9">
              <div class="checkbox-inline">
                <template v-for="item in testMethodList">
                  <label class="checkbox pb-1" :key="item.recordId" style="min-width: 7rem;">
                    <input type="checkbox" class="form-control" id="position" :value="item.checked" v-model="item.checked" v-on:change="handleCheckboxChange(item,testMethodList)"/>
                    <span></span>
                    {{item.value}}
                  </label>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import i18nService from "@/core/services/i18n.service";
import store from "@/core/services/store";
export const SETAUTH = "setauth";
export default {
  mounted() {
    this.loadMsg();
  },
  computed: {
    user: {
      get () {return this.$store.getters.currentUser;}
    },
    activeLanguage() {
      return i18nService.getActiveLanguage();
    }
  },
  data(){
    return{
      quotationDetailList:[],
      exportUrl:this.url+'/crm/quotation/print',
      detailId:"",
      boardLevelList:[], //PCB类型
      materialTypeList:[],// 覆铜板材
      boardThicknessList:[],// 板材厚度
      copperCladThicknessList:[], //覆铜要求
      surfaceProcessList:[], //镀层处理
      solderMaskTypeList:[], //阻焊类型
      characterTypeList:[], //板面字符
      shapingWayList:[], //成型方式
      testMethodList:[], //测试要求
      boardLeve:"",
      auditFlag:10,
      result:"",
      craftValue:"",
      craftMaterialValue:"",
      craftMaterialValueList:[],
      productTypeList:[],
      countryList:[],
      showQuotationDetailList:[],
      code: 'ld',
      userInfo: {},
      exposurePrintingList:[],
      exchangeRate:null,
    }
  },
  methods:{
    loadMsg: function (){
      if (this.user && this.user.recordId){
        this.loadExchangeRate();
        this.userInfo.recordId = this.user.recordId;
        this.userInfo.userName = this.user.userName;
        this.userInfo.email = this.user.email;
        this.userInfo.phone = this.user.phone;
        this.userInfo.requireType = this.user.requireType;
        this.userInfo.annualDemand = this.user.annualDemand;
        this.userInfo.country = this.user.country;
        this.userInfo.profession = this.user.profession;
        this.userInfo.unit = this.user.unit;
      }else {
        this.userInfo = {};
        this.userInfo.code = this.code;
      }
      if (this.activeLanguage == 'en'){
        this.userInfo.unit = "2";
      }else{
        this.userInfo.unit = "1";
      }
      // 获取国家、产品、工艺等数据
      this.loadDateT();
    },
    emailRegister(){
      //线上下单注册可直接生成客户资料进行下单
      this.userInfo.onlineRegisterT = "1";
      this.$axios.fetchPost("hr/user/emailRegister", this.userInfo).then(result => {
        if (result.data){
          if (result.data == "refresh"){
            alert(this.$t('AUTH.REGISTER.DESC'));
          }else {
            this.getUser(1);
          }
        }else {
          alert(this.$t('AUTH.REFRESH'));
        }
      }).catch(err=> {
        alert(err)
      });
    },
    saveInfo() {
      if (this.userInfo && this.userInfo.recordId){
        if (!this.userInfo.userName){
          alert(this.$t('AUTH.VALIDATION.FULLNAME'));
          return;
        }
        this.userInfo.cloud = "3";
        const _this = this;
        this.$axios.fetchPost("hr/user/saveInfo",this.userInfo).then(result => {
          if(result.data.recordId){
            _this.getUser(2);
            //筛选报价清单
            this.getQuotationDetailList();
          }
        }).catch(err => {console.log(err);});
      }
    },
    getUser(number) {
      const user = {};
      if (this.user && this.user.recordId){
        user.recordId = this.user.recordId;
        user.defaultDb = this.user.defaultDb;
        user.groupManageId = this.user.groupManageId;
      }else {
        user.phone = this.userInfo.phone;
        user.email = this.userInfo.email;
        user.code = this.code;
      }
      user.cloud = "3";
      this.$axios.fetchPost("hr/user/getUser", user).then(result => {
        if(result.data.recordId && result.data.groupManageId && result.data.defaultDb){
          // location.reload();
          store.dispatch(SETAUTH, result.data);
          this.getQuotationDetailList();
          if (number === 1){
            location.reload();
          }
        }
      }).catch(err => {console.log(err);});
    },
    loadDateT() {
      const query = {};
      query.code = this.code;
      if (this.user && this.user.phone){
        query.phone = this.user.phone;
      }
      query.activeLanguage = this.activeLanguage;
      const _this = this;
      this.$axios.fetchPost("is/offer/loadMsg", query).then(result => {
        _this.productTypeList = result.data.productTypeList;
        _this.countryList = result.data.countryList;
            if(_this.activeLanguage && _this.activeLanguage == 'en')
            {
              if (_this.productTypeList && _this.productTypeList.length > 0){
                for(let product of this.productTypeList){
                  product.value = product.enName;
                }
              }
              if (_this.countryList && _this.countryList.length > 0){
                for(let country of _this.countryList){
                  country.countryName = country.enName;
                }
              }
            }
          for(let product of _this.productTypeList){
            if (_this.user && _this.user.profession){
              let array = _this.user.profession.split(",");
              for(let sectionValue of array){
                if (product.recordId === sectionValue){
                  product.checked = true;
                  continue;
                }
              }
            }
          }
            // this.handleSelectCountryT();
      }).catch(err=> {
        alert(err)
      });
    },
    // handleSelectCountryT() {
    //   // $('#countryT').empty();
    //   // let option = '';
    //   // option += "<option value=''>" + '请选择' + '</option>';
    //   // this.countryList.forEach(el => {
    //   //   option += "<option value='" + el.recordId + "'>" + el.countryName + '</option>';
    //   // });
    //   // $('#countryT').append(option);
    //   // $('#countryT').selectpicker('val', this.userInfo.country);
    //   // $('#countryT').selectpicker('render');
    //   // $('#countryT').selectpicker('refresh');
    //   // $('#countryT').selectpicker();
    // },

    getQuotationDetailList(){
      const query = {};
      if (this.userInfo && this.userInfo.profession){
        query.profession = this.userInfo.profession;
      }else{
        query.profession = this.user.profession;
      }
      query.activeLanguage = this.activeLanguage;
      const _this = this;
      this.$axios.fetchPost("is/offer/getQuotationDetailList",query).then(result => {
        _this.quotationDetailList = result.data.quotationDetailList;
        _this.showQuotationDetailList = result.data.quotationDetailList;
        if(_this.activeLanguage && _this.activeLanguage == 'en')
        {
          if (_this.quotationDetailList && _this.quotationDetailList.length > 0){
            for(let quotationDetail of _this.quotationDetailList){
              let craftConcat = null;
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.productTypeValueE.slice(0,8));
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.boardLevelValueE);
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.boardThicknessValue);
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.copperCladThicknessValueE);
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.solderMaskTypeValueE);
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.surfaceProcessValueE);
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.shapingWayValueE);
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.materialTypeValueE);
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.characterTypeValueE);
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.testMethodValueE);
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.specialCraftValueE);
              if (quotationDetail.processValueId == '1'){
                quotationDetail.processValueId = "Exposure";
              } else if (quotationDetail.processValueId == '2'){
                quotationDetail.processValueId = "Screen printing";
              }
              craftConcat = _this.setConcatValue(craftConcat,quotationDetail.processValueId);
              quotationDetail.concatValue = craftConcat;
            }
          }
        }
      }).catch(err => {
        alert(err)
      });
    },
    //换算汇率
    loadExchangeRate(){
      if (this.user && this.user.recordId){
        const entity = {};
        entity.defaultDb = this.user.defaultDb;
        entity.groupManageId = this.user.groupManageId;
        entity.userId = this.user.recordId;
        entity.currencyType = "14667";
        const _this = this;
        this.$axios.fetchPost("is/offer/getExchangeRate", entity).then(result => {
          _this.exchangeRate = result.data.rate;
          this.getQuotationDetailList();
        }).catch(err => {alert(err)});
      }
    },


    setLanguageValue:function(list){
      if (list && list.length > 0){
        for(let obj of list)
        {
          obj.value = obj.enName;
          obj.item.itemName = obj.item.enName;
        }
      }
    },
    setCheck:function(){
      if(this.craftMaterialValueList && this.craftMaterialValueList.length > 0)
      {
        for(let craftMaterialValue of this.craftMaterialValueList)
        {
          for(let value of craftMaterialValue.valueList)
          {
            this.setChildCheck(value,this.boardLevelList);
            this.setChildCheck(value,this.materialTypeList);
            this.setChildCheck(value,this.boardThicknessList);
            this.setChildCheck(value,this.copperCladThicknessList);
            this.setChildCheck(value,this.surfaceProcessList);

            this.setChildCheck(value,this.solderMaskTypeList);
            this.setChildCheck(value,this.characterTypeList);
            this.setChildCheck(value,this.shapingWayList);
            this.setChildCheck(value,this.testMethodList);
            this.setChildCheck(value,this.exposurePrintingList);
          }
        }
      }
    },
    setChildCheck:function(value,list){
      if(list && list.length > 0)
      {
        for(let obj of list)
        {
          if(obj.recordId == value.recordId)
          {
            this.$set(obj,'checked',true);
            break;
          }
        }
      }
    },
    addCraft() {
      const _this = this;
      this.$axios.fetchPost("is/offer/loadCraftList",{}).then(result => {
        _this.boardLevelList = result.data.boardLevelList;
        _this.materialTypeList = result.data.materialTypeList;
        _this.boardThicknessList = result.data.boardThicknessList;
        _this.copperCladThicknessList = result.data.copperCladThicknessList;
        _this.surfaceProcessList = result.data.surfaceProcessList;

        _this.solderMaskTypeList = result.data.solderMaskTypeList;
        _this.characterTypeList = result.data.characterTypeList;
        _this.shapingWayList = result.data.shapingWayList;
        _this.testMethodList = result.data.testMethodList;
        //定义曝光、丝印集合
        _this.exposurePrintingList = this.makeExposurePrintingList();
        if(_this.activeLanguage && _this.activeLanguage == 'en')
        {
          this.setLanguageValue(_this.boardLevelList);
          this.setLanguageValue(_this.materialTypeList);
          this.setLanguageValue(_this.boardThicknessList);
          this.setLanguageValue(_this.copperCladThicknessList);
          this.setLanguageValue(_this.surfaceProcessList);

          this.setLanguageValue(_this.solderMaskTypeList);
          this.setLanguageValue(_this.characterTypeList);
          this.setLanguageValue(_this.shapingWayList);
          this.setLanguageValue(_this.testMethodList);
          this.setLanguageValue(_this.exposurePrintingList);
        }
        _this.setCheck();
        _this.$refs['addCraft'].show();
      }).catch(err => {
        alert(err)
      });
    },
    makeExposurePrintingList:function (){
      let exposurePrintingList = [];
      let query = {};
      query.value = "曝光";
      query.enName = "Exposure";
      query.recordId = "1"
      query.item = {};
      query.item.itemName = "曝光/丝印";
      query.item.enName = "ExposurePrinting";
      query.item.recordId = "1";
      exposurePrintingList.push(query);

      let queryTwo = {};
      queryTwo.value = "丝印";
      queryTwo.enName = "Screen printing";
      queryTwo.recordId = "2";
      queryTwo.item = {};
      queryTwo.item.itemName = "曝光/丝印";
      queryTwo.item.enName = "ExposurePrinting";
      queryTwo.item.recordId = "1";
      exposurePrintingList.push(queryTwo);
      return exposurePrintingList;
    },

    selectCraftType: function(num) {
      if (num && Number(num) > 0) {
        this.auditFlag = num;
      }
    },
    setConcatValue:function(oldValue,nowValue){
      if(nowValue)
      {
        if(oldValue)
        {
          oldValue = oldValue +","+ nowValue;
        }
        else
        {
          oldValue = nowValue;
        }
      }
      return oldValue;
    },
    delQuotationDetail(index)
    {
      this.quotationDetailList.splice(index, 1);
    },
    handleCheckboxChange(selectedOption,itemList) {
      let valueList = [];
      for(let i = 0; i < itemList.length; i++)
      {
        if(itemList[i].checked)
        {
          valueList.push(itemList[i]);
        }
      }
      let item = {};
      if(this.craftMaterialValueList && this.craftMaterialValueList.length > 0)
      {
        for(let craftMaterialValue of this.craftMaterialValueList)
        {
          if(craftMaterialValue.recordId == selectedOption.item.recordId)
          {
            item = craftMaterialValue;
            break;
          }
        }
      }
      item.valueList = valueList;
      if(!item.recordId)
      {
        item.recordId = selectedOption.item.recordId;
        item.itemName = selectedOption.item.itemName;
        this.craftMaterialValueList.push(item);
      }
      this.craftValue = "";
      for(let craftT of this.craftMaterialValueList)
      {
        if (craftT.valueList && craftT.valueList.length > 0){
          if(this.craftValue)
          {
            this.craftValue = this.craftValue +" "+ craftT.itemName +" ";
          }
          else
          {
            this.craftValue = craftT.itemName +" ";
          }
        }
        let i = 0;
        for(let value of craftT.valueList)
        {
          if(i == 0)
          {
            this.craftValue = this.craftValue +" "+ value.value;
          }
          else
          {
            this.craftValue = this.craftValue +","+ value.value;
          }
          i++;
        }
      }
    },
    confirmSelection() {
      this.$refs['addCraft'].hide();
      this.craftMaterialValue = this.craftValue;
      this.quotationDetailList = this.showQuotationDetailList;
      let list = [];
      let i = 0;
      for(let craftMaterialValue of this.craftMaterialValueList)
      {
        if (craftMaterialValue.valueList && craftMaterialValue.valueList.length > 0){
          i++;
          for(let value of craftMaterialValue.valueList)
          {
            list = list.concat(this.filterCollectionByCraft(value.value, this.quotationDetailList));
          }
          this.quotationDetailList = list;
          list = [];
        }else if (i == 0){
          this.quotationDetailList = this.showQuotationDetailList;
        }
      }
      },

     filterCollectionByCraft(craftValue, collectionList)
      {
        let listT = [];
        for(let item of collectionList){
          let flag = false;
          let array = [];
          if (this.activeLanguage && this.activeLanguage == 'en'){
            array = item.concatValue.split(",");
          }else{
            array = item.concatValue.split(" ");
          }
           for(let list of array){
             if (list == craftValue){
               flag = true;
             }
           }
           if (flag){
             listT.push(item);
           }
          }
        return listT;
      },
    downloadPrint() {
      const query = {};
      this.detailId = "";
      for(let detail of this.quotationDetailList){
        if (this.detailId === ""){
          this.detailId = detail.recordId;
        }else{
          this.detailId = this.detailId + "," + detail.recordId;
        }
      }
      query.detailId = this.detailId;
      query.defaultDb = this.user.defaultDb;
      query.activeLanguage = this.activeLanguage;
      query.exchangeRate = this.exchangeRate;
      const icloudUser = {}
      icloudUser.userName = this.user.userName;
      icloudUser.phone = this.user.phone;
      icloudUser.email = this.user.email;
      icloudUser.country = this.user.country;
      query.icloudUser = icloudUser;
      this.$axios.fetchPostArray("kybAudit/onlinePrint", query).then(data => {
        const headers = data.headers;
        const a = document.createElement("a");
        const file = new Blob([data.data], {
          type: "application/pdf"
        });
        const fileURL = (window.URL || window.webkitURL).createObjectURL(
            file
        );
        a.href = fileURL;
        a.download = decodeURI(headers.title);
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
          document.body.removeChild(a);
          URL.revokeObjectURL(fileURL);
        }, 100);

      })
          .catch(err => {
            console.log(err);
          });
    },
    checkboxChange(item,list){
      let result = "";
      for(let i = 0; i < list.length; i++){
        if (list[i].checked){
          if (result == ""){
            result = list[i].recordId;
          }else{
            result = result + "," + list[i].recordId;
          }
        }
      }
      this.userInfo.profession = result;
      this.craftMaterialValue = "";
      this.craftMaterialValueList = [];
      this.craftValue = "";
      this.saveInfo();
    }
  }
}
</script>